<template>
  <div >
    
        <MenuLkBit />
    <div style="left:20px; position:absolute; top: 20px">
      <FooterLkLeft />
    </div>
  </div>
</template>
<script>
import { useMyStorage } from "@/store/global";

import MenuLkBit from './MenuLkBit'
import FooterLkLeft from './FooterLkLeftSmall'

export default {
  components:{

    MenuLkBit,
    FooterLkLeft,
    
  },
  setup(){
    const store = useMyStorage();
    return {
      store
    }
  }
};
</script>
<style lang="scss">

#lk_left_panel {
  width: 560px;
//  height: 1080px;
  background-color: #f7f7f7;
}

#lk_left_panel_points {
  position: absolute;
  left: 23px;
  top: 23px;
  width: 159px;
  //height: 1080px;
  overflow: hidden;
  background-image: url("data:image/svg+xml;utf8,<svg width='159' height='26' viewBox='0 0 159 26' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='53.5' cy='1.5' r='1.5' fill='%23E0E0E0'/><circle cx='79.5' cy='1.5' r='1.5' fill='%23E0E0E0'/><circle cx='1.5' cy='1.5' r='1.5' fill='%23E0E0E0'/><circle cx='105.5' cy='1.5' r='1.5' fill='%23E0E0E0'/><circle cx='27.5' cy='1.5' r='1.5' fill='%23E0E0E0'/><circle cx='131.5' cy='1.5' r='1.5' fill='%23E0E0E0'/><circle cx='157.5' cy='1.5' r='1.5' fill='%23E0E0E0'/></svg>");
  background-repeat: repeat-y;
  margin-bottom: -23px;
}
</style>